import store from "@/plugins/store";

function Timesheet() {
	// Fields of our timesheet as we retrieve them from our get API
	this.id = 0;
	this.is_freelance = false;
	this.reversed = null;
	this.reentry = null;
	this.period = { id: 0, display_name: '' };
	this.address_book = { id: 0, code: '', display_name: '', uri: ''}
	this.job = { id: 0, code: '', display_name: '', uri: ''}
	this.phase = { id: 0, display_name: '' };
	this.kind = { id: 0, code: '', display_name: '' };
	this.division = { id: 0, display_name: '' };
	this.acoc = 0;
	this.date = new Date();
	this.start = null;
	this.stop = null;
	this.duration = 0; // minutes!
	this.value = 0.0;
	this.notes = '';
	this.is_approved = false;
	this.is_invoiced = false;
	this.task = { id: 0, display_name: '', budget: 0, budget_value: 0.0, status_id: 0, status: '', is_completed: false };

	// helper fields
	this.org_task_status_id = 0;
	this.hours = 0;
	this.minutes = 0;

	this.date_to_ymd = function(date) {
		// should import this somehow
		let ymd = date.getFullYear();

		let month = 1 + date.getMonth();
		if (month < 10) {
			ymd = ymd + '0' + month;
		} else {
			ymd = ymd + '' + month;				
		}

		let day = date.getDate();
		if (day < 10) {
			ymd = ymd + '0' + day;
		} else {
			ymd = ymd + '' + day;				
		}

		return ymd;
	};

	this.reset_task = function() {
		this.task = { id: 0, display_name: '', budget: 0, budget_value: 0.0, status_id: 0, status: '', is_completed: false };
		this.org_task_status_id = 0;
	};

	this.set = function(timesheet) {
		this.id = timesheet.id;
		this.is_freelance = timesheet.is_freelance;
		this.reversed = timesheet.reversed;
		this.reentry = timesheet.reentry;
		this.period = timesheet.period;
		this.address_book = timesheet.address_book
		this.job = timesheet.job;
		this.phase = timesheet.phase;
		this.kind = timesheet.kind;
		this.division = timesheet.division;
		this.acoc = timesheet.acoc;
		this.date = new Date(timesheet.date);
		this.start = timesheet.start;
		this.stop = timesheet.stop;
		this.duration = timesheet.duration; // minutes!
		this.value = timesheet.value;
		this.notes = timesheet.notes;
		this.is_approved = timesheet.is_approved;
		this.is_invoiced = timesheet.is_invoiced;
		this.task = timesheet.task;

		if (this.task) {
			this.org_task_status_id = this.task.status_id
		} else {
			this.reset_task();
		}
		this.hours = Math.floor(this.duration / 60.0);
		this.minutes = this.duration - (60.0 * this.hours);	

		// console.log(this);
	};

	this.load = function(timesheet_id) {
		let self = this; // make sure we can access this inside of our promisses

		return new Promise((resolve, reject) => {
			// build our url parameters
			let params = new Array();
			// params.push("timesheet_kinds=true");

			// build our url, we have to add url escaping here!
			let url = "/api/timesheets/" + timesheet_id;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// parse our new data
						self.set(json.data);

						resolve();
					} else {
						reject(json.reason);
					}
				})
				.catch(function(e) {
					reject(e.message);
				});
		});
	};

	this.insert = function() {
		let self = this;

		return new Promise((resolve, reject) => {
			// build our url parameters
			let params = new Array();
			// params.push("timesheet_kinds=true");

			// build our url, we have to add url escaping here!
			let url = "/api/timesheets";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			// console.log(url);
			let task_id = self.task ? self.task.id : 0;

			axios
				.post(url, {
					date: self.date_to_ymd(self.date),
					duration: (parseInt(self.hours) * 60) + parseInt(self.minutes),
					// employee_id: 0, <-- obtained from current user
					// is_external: false, <-- obtained from current user
					task_id: task_id,
					phase_id: task_id == 0 ? self.phase.id : 0,
					kind_id: task_id == 0 ? self.kind.id : 0,
					acoc: self.acoc,
					notes: self.notes
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					// this is the result of the last search we've started, lets process it.
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// parse our new data
						self.set(json.data);

						resolve(json.data);
					} else {
						console.log(json.reason);
						reject(json.reason);
					}
				})
				.catch(function(e) {
					// this is the error for the last search we've started, lets show it.
					console.log(e);
					reject(e.message);
				})
		});
	};

	this.update = function() {
		let self = this;

		return new Promise((resolve, reject) => {

			// build our url parameters
			let params = new Array();
			// params.push("timesheet_kinds=true");

			// build our url, we have to add url escaping here!
			let url = "/api/timesheets/" + self.id;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			// console.log(url);
			let task_id = self.task ? self.task.id : 0;

			axios
				.put(url, {
					date: self.date_to_ymd(self.date),
					duration: (parseInt(self.hours) * 60) + parseInt(self.minutes),
					// employee_id: 0, <-- don't change, keep from current timesheet
					// is_external: false, <-- don't change, keep from current timesheet
					task_id: task_id,
					phase_id: task_id == 0 ? self.phase.id : 0,
					kind_id: task_id == 0 ? self.kind.id : 0,
					acoc: self.acoc,
					notes: self.notes
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					// this is the result of the last search we've started, lets process it.
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// parse our new data
						self.set(json.data);

						resolve();
					} else {
						reject(json.reason);
					}
				})
				.catch(function(e) {
					reject(e.message);
				});	
		});
	}

	this.delete = function() {
		let self = this;

		return new Promise((resolve, reject) => {
			axios
				.delete("/api/timesheets/" + self.id, {
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					// Don't ask me why it does work here... 
					let json = d.data;
					
					if (json.status == "OK") {
						// self.set(json.data);
						resolve();
					} else {
						console.log(json.reason);
						reject(json.reason);
					}
				})
				.catch(function(e) {
					console.log(e);
					reject(e.message);
				})

		})		
	}
}

export default Timesheet;
